import * as React from 'react'
import { broadcastFormSteps } from '$views/RecommendationsForms/BroadcastForm/BroadcastForm'
import { Field } from 'formik'
import { HoursPerWeekField } from '$views/RecommendationsForms/BroadcastForm/components/HoursPerWeek/components/HoursPerWeekField'

export const HoursPerWeek: React.FC<Props> = () => {
  const getNumberOptions = () => {
    const numberOptions = [{ label: 'Interna', value: 'Interna' }]

    for (let index = 1; index <= 40; index++) {
      numberOptions.push({
        label: index.toString(),
        value: index.toString(),
      })
    }

    return numberOptions
  }

  return (
    <>
      <Field
        component={HoursPerWeekField}
        name={broadcastFormSteps.serviceInformationStep.hoursPerWeek}
        list={getNumberOptions()}
      />
    </>
  )
}



// WEBPACK FOOTER //
// ./src/views/RecommendationsForms/BroadcastForm/components/HoursPerWeek/HoursPerWeek.tsx